import { t } from "ttag";

import { FullscreenAlert, LetterIcon } from "@/shared/ui";

export const CallCenterPaymentSuccessAlert = () => (
  <FullscreenAlert.Root open>
    <FullscreenAlert.Content>
      <FullscreenAlert.Header icon={LetterIcon}>
        <FullscreenAlert.Title>{t`Payment successful!`}</FullscreenAlert.Title>

        <FullscreenAlert.Description>
          {t`The payment was processed successfully. The patient will receive an email with a link to set their password and access their account.`}
        </FullscreenAlert.Description>
      </FullscreenAlert.Header>
    </FullscreenAlert.Content>
  </FullscreenAlert.Root>
);
